import { ConfirmDialog } from '@/components/confirm-dialog'
import { listWhatsappConnectionQuery } from '@/queries/whatsapp.query'
import { WhatsappService } from '@/services/whatsapp.service'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { toast } from 'sonner'
import { selectCurrent, selectOpen, selectSetCurrent, selectSetOpen, useConnectionStore } from '../store'
import { ConnectionsMutateDrawer } from './connections-mutate-drawer'
import { ConnectionsQrCodeDialog } from './qr-code-dialog'

let toastId: string | number;

export function ConnectionsDialogs() {
  const open = useConnectionStore(selectOpen);
  const setOpen = useConnectionStore(selectSetOpen);
  const current = useConnectionStore(selectCurrent);
  const setCurrent = useConnectionStore(selectSetCurrent);
  const queryClient = useQueryClient();
  const removeConnectionMutation = useMutation({
    mutationFn: WhatsappService.removeConnection,
    onMutate: () => {
      toastId = toast.loading('Removendo conexão...')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listWhatsappConnectionQuery.queryKey })
      toast.success('conexão com whatsapp removida!', {
        id: toastId
      });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: listWhatsappConnectionQuery.queryKey })
      toast.error('Ocorreu um erro ao tentar remover conexão.', {
        id: toastId
      });
    }
  });

  return (
    <>
      <ConnectionsMutateDrawer
        key='connection-create'
        open={open === 'create'}
        onOpenChange={() => setOpen('create')}
      />

      <ConnectionsQrCodeDialog
        key='connection-connect'
        open={open === 'connect'}
        onOpenChange={() => setOpen('connect')}
      />

      {current && (
        <>
          <ConnectionsMutateDrawer
            key={`connection-update-${current.id}`}
            open={open === 'update'}
            onOpenChange={() => {
              setOpen('update')
              setTimeout(() => {
                setCurrent(null)
              }, 500)
            }}
            current={current}
          />

          <ConfirmDialog
            key='connection-delete'
            destructive
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrent(null)
              }, 500)
            }}
            handleConfirm={() => {
              removeConnectionMutation.mutate(current.id);
              setOpen(null)
              setTimeout(() => {
                setCurrent(null)
              }, 500)
            }}
            className='max-w-md'
            title={`Remover conexão: ${current.name} ?`}
            desc={
              <React.Fragment>
                Você está prestes a excluir uma conexão com o nome{' '}
                <strong>{current.name}</strong>. <br />
                Esta ação não pode ser desfeita.
              </React.Fragment>
            }
            confirmText='Remover'
          />
        </>
      )}
    </>
  )
}
